import { z } from 'zod';
// ─── Grammar / spelling check ────────────────────────────────────────────────
export const grammarCheckSchema = z.object({
    text: z.string().min(1).max(20000),
});
// ─── Generic email composer ──────────────────────────────────────────────────
export const emailRecipientSchema = z.object({
    email: z.string().email().max(320),
    name: z.string().max(255).nullable().optional(),
});
export const emailAttachmentRefSchema = z.object({
    s3Key: z.string().min(1).max(1024),
    fileName: z.string().min(1).max(512),
    mimeType: z.string().min(1).max(255),
});
export const composeEmailSchema = z.object({
    recipients: z.array(emailRecipientSchema).min(1).max(200),
    subject: z.string().min(1).max(500),
    bodyHtml: z.string().min(1).max(100000),
    ccSelf: z.boolean().optional(),
    attachments: z.array(emailAttachmentRefSchema).max(20).optional(),
    context: z.string().max(100).optional(),
});
// ─── Public vendor upload ────────────────────────────────────────────────────
export const vendorUploadCreateSchema = z.object({
    s3Key: z.string().min(1).max(1024),
    fileName: z.string().min(1).max(512),
    mimeType: z.string().min(1).max(255),
    fileSizeBytes: z
        .number()
        .int()
        .min(0)
        .max(100 * 1024 * 1024)
        .optional(),
});
//# sourceMappingURL=messaging.js.map